module.exports = __webpack_public_path__ + "images/cb1dce848a8e6d84043ebe0b1e6d36c8.png";